
import { URL as URLstring } from './config.js';
import { axios } from './handlers/RequestHandler';
import store from './store/store.js';
import {
	fetchProvider,
	updateBranch,
	fetchBranch,
	fetchCoupon,
	fetchGood,
	fetchCompany
} from './api/ondemand';
import {
	couponStatus, isPickUp,
	orderStatus
} from './store/actions/UtilsOperation';
import {
	WAITING_PAYMENT,
	MASK_SERVICE_TYPE,
	TYPE_SERVICES
} from './constants/bitwiseOperations';
import {
	COMPANY_ACCESS
} from './constants/general';
import { isOrdersListPath } from './utils/permissions';
let json_lang = store.getState().json_lang;

const notificationOptionSetting = async (payload, data, notification, session, dispatch) => {	
	// session se envia solo cuando llega un push, desde la vista de Lista de Notificaciones este es undefined siempre
	const sound = session && session.settings.preferences && session.settings.preferences.audible_notifications;
	const firstPathSegment = window.location.pathname.split("/")[1];
	const hasListOfOrdersView = isOrdersListPath(firstPathSegment) || firstPathSegment === 'map';  // debo incluir esto porque al agregar el "search-status" en la url de "order-management" deja de coincidir
	const hasListOfProvidersView = ['/provider-management', '/map'].includes( window.location.pathname );
	const isMapView = ['/map'].includes(window.location.pathname);
	const isBranchListView = ['/branchs'].includes(window.location.pathname);
	const activeBranch = JSON.parse(localStorage.getItem("activeBranch"));
	const userHigherAccess = JSON.parse(localStorage.getItem("userHigherAccess"));
	let fetchedData = {};
	let ignorePush = false;
	/* Los default se mantienen comentados, xq por ahora la unica forma de saber de que comercio son los push no es posible desde el api, entonces para evitar que lleguen notificaciones por defecto/no reconocidas a cualquier comercio se opta por ocultar las default */
	let PAYLOAD = ((payload && payload.data) || payload);
	
	let orderIdToUpdate;

	if (PAYLOAD.type === 'order') {
		fetchedData = notification.update;
		orderIdToUpdate = notification.update.id;
		// const orderFromNotificaion = (notification.related || notification.update) || null;
		// if (orderIdToUpdate) {
		// 	fetchedData = orderFromNotificaion ?  orderFromNotificaion : (orderIdToUpdate && await fetchOrder(orderIdToUpdate));
		// 	notification.update = {
		// 		...fetchedData
		// 	};
		// }
	} else if (PAYLOAD.type === 'order_provider' || PAYLOAD.type === "payment"){
		orderIdToUpdate = notification.update.order_id ? notification.update.order_id : notification.update.id;

		if (orderIdToUpdate) {
			// fetchedData = orderIdToUpdate && await fetchOrder(orderIdToUpdate);
			// notification.update = {
			// 	...fetchedData
			// };
			fetchedData = notification.update;
		}
	} else {
		fetchedData = (notification.related || (PAYLOAD.related || PAYLOAD.data)) || {};
		notification.update = {
			...fetchedData
		};
	}

	// console.log("PAYLOAD ========>",PAYLOAD);
	// console.log("notification ========>",notification);
	// console.log("fetchedData ========>",fetchedData);
	// console.log("session ========>",session);

	switch (PAYLOAD.action) {
		
		case 'new':
			switch (PAYLOAD.type) {
				case 'order':
					
					if( PAYLOAD.data && PAYLOAD.data.number !== null && session.admin_type_id === 2 ){
						return;
					}

					/*if (activeBranch && activeBranch.id && (fetchedData && fetchedData.branch && fetchedData.branch.id) !== activeBranch.id) {
						// soy admin de dondemand, pero estoy viendo otro comercio
						ignorePush = true;
					}*/

					notification.sticky = true;
					notification.title = json_lang.firebase.new_order__title;
					if(fetchedData.branch)
						notification.title.replace("-", `- ${fetchedData.branch.name} -`)
					notification.msg = fetchedData.uid ? json_lang.firebase.new_order__msg.replace("{number}", fetchedData.uid) : json_lang.firebase.new_order__msg.replace(" # {number} ", "");

					if (fetchedData.branch){
						notification.title.replace("-", `- ${fetchedData.branch.name} -`)
						notification.msg = fetchedData.branch.name + ": " + notification.msg;
					}
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.sound = sound && sound.order_new !== "off" ? sound.order_new : null;

					if (ignorePush && hasListOfOrdersView) {
						// si estoy en otro comercio solo muestra la notificacion, no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
						notification.operation = "notification-only";
					}
					else {
						notification.operation = "replace-from-paginated-list";
						//notification.related ? "replace-from-list" : 'append';
						notification.storeKey = isMapView ? 'filteredMapOrders' : 'orders';
					}
					break;

				// case 'payment':

				// 	if ( !(userHigherAccess === COMPANY_ACCESS) ) { // si soy owner oculta
				// 		ignorePush = true;
				// 	}
				// 	notification.title = json_lang.firebase.new_payment__title;
				// 	notification.sound = sound && sound.payment_new !== "off" ? sound.payment_new : null;
				// 	notification.msg = json_lang.firebase.new_payment__msg.replace("{number}", (fetchedData && fetchedData.uid));
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	//notification.touchedPropsToReplace = ["status"]; */
				// 	break;

				case 'clientrating':
					fetchedData = (notification && notification.related) || {} // await fetchClientRating(notification.update.order_id);
					notification.update = {
						...fetchedData
					};

					notification.title = json_lang.firebase.new_clientrating__title;
					notification.msg = json_lang.firebase.new_clientrating__msg.replace("{rate}", fetchedData.rate || '');
					notification.url = '/order-management/' + orderIdToUpdate;
					break;

				case 'rating':
					notification.title = json_lang.firebase.new_rating__title;
					notification.msg = json_lang.firebase.new_rating__msg;
					const rating_id = {} // await fetchRating(notification.update.id);
					notification.update = {
						...rating_id
					};
					break;

				case 'bid':
					notification.title = json_lang.firebase.new_bid__title;
					notification.msg = json_lang.firebase.new_bid__msg;
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = []; /* xHACER: */
					break;

				case 'pending_action':
					if (userHigherAccess === COMPANY_ACCESS) {
						notification.title = json_lang.firebase.new_pending_action__title;
						notification.msg = json_lang.firebase.new_pending_action__msg;
						notification.update = {
							...fetchedData
						};
					}
					break;

				default:
					//notification.title = json_lang.firebase.new_default__title;
					//notification.msg = json_lang.firebase.new_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'available':
			switch (PAYLOAD.type) {
				case 'order':

					notification.title = json_lang.firebase.available_order__title;
					notification.msg = json_lang.firebase.available_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					break;

				case 'bid':

					notification.title = json_lang.firebase.available_bid__title;
					notification.msg = json_lang.firebase.available_bid__msg;
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = []; /* xHACER: */
					break;

				case 'good':
					fetchedData = (notification && notification.related) || await fetchGood(notification.update.id);
					notification.update = {
						...fetchedData
					};

					notification.title = json_lang.firebase.available_good__title;
					notification.msg = json_lang.firebase.available_good__msg.replace("{name}", fetchedData.name);
					notification.url = '/goods-management/' + data.id;
					break;

				case 'payment':

					notification.title = json_lang.firebase.available_payment__title;
					notification.msg = json_lang.firebase.available_payment__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.url = '/order-management/' + orderIdToUpdate;
					break;

				case 'provider':
					fetchedData = (notification && notification.related) || await fetchProvider(notification.update.id);
					notification.update = {
						...fetchedData
					};

					notification.title = json_lang.firebase.available_provider__title;
					notification.msg = json_lang.firebase.available_provider__msg.replace("{provider}", fetchedData.name);
					notification.operation = hasListOfProvidersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management';
					notification.storeKey = notification.operation === 'replace' ? 'provider' : 'providers';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				default:
					//notification.title = json_lang.firebase.available_default__title;
					//notification.msg = json_lang.firebase.available_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'unavailable':
			switch (PAYLOAD.type) {
				case 'order':

					notification.title = json_lang.firebase.unavailable_order__title;
					notification.msg = json_lang.firebase.unavailable_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				case 'provider':
					fetchedData = (notification && notification.related) || await fetchProvider(notification.update.id);
					notification.update = {
						...fetchedData
					};

					notification.title = json_lang.firebase.unavailable_provider__title;
					notification.operation = hasListOfProvidersView ? 'replace-from-list' : 'replace';
					notification.msg = json_lang.firebase.unavailable_provider__msg.replace("{provider}", fetchedData.name);
					notification.storeKey = notification.operation === 'replace' ? 'provider' : 'providers';
					notification.touchedPropsToReplace = []; /* xHACER: */
					break;

				case 'good':
					fetchedData = (notification && notification.related) || await fetchGood(notification.update.id);
					notification.update = {
						...fetchedData
					};

					notification.title = json_lang.firebase.unavailable_good__title;
					notification.msg = json_lang.firebase.unavailable_good__msg.replace("{name}", fetchedData.name);
					notification.url = '/goods-management/' + data.id;
					break;

				default:
					//notification.title = json_lang.firebase.unavailable_default__title;
					//notification.msg = json_lang.firebase.unavailable_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'cancelled':
			switch (PAYLOAD.type) {
				case 'order':
					// si yo soy tipo branch y se cancela la orden sin confirmar el pago, no me muestres notificacion de cancelada
					if (userHigherAccess !== COMPANY_ACCESS && (parseInt(fetchedData.status, 10) & WAITING_PAYMENT) === 0) {
						ignorePush = true;
					}
					notification.title = json_lang.firebase.canceled_order__title;
					notification.sound = sound && sound.order_canceled !== "off" ? sound.order_canceled : null;
					notification.msg = json_lang.firebase.canceled_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.operation = 'replace';//hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				case 'payment':
					ignorePush = true;
					break;

				default:
					//notification.title = json_lang.firebase.canceled_default__title;
					//notification.msg = json_lang.firebase.canceled_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'started':
			switch (PAYLOAD.type) {
				case 'order':
					let isService = ((fetchedData.status & MASK_SERVICE_TYPE) === TYPE_SERVICES);

					const status_type = !isPickUp(fetchedData.client_latitude_e6, fetchedData.client_longitude_e6, fetchedData.client_address) && !isService ? json_lang.firebase.the_way : json_lang.firebase.progress;

					notification.title = json_lang.firebase.started_order__title.replace("{status_type}", status_type);
					notification.msg = json_lang.firebase.started_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id)).replace("{status_type}", status_type);

					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				// case 'order_provider':


				// 	//if (userHigherAccess < COMPANY_ACCESS){ // TODO: esta validacion no se si deberia existir, el comentario de abajo ya estaba en liveri pero el if no estaba comentado
				// 		/* notification.sticky = true;

				// 		notification.title = json_lang.firebase.started_orderprovider_branch__title;
				// 		notification.msg = json_lang.firebase.started_orderprovider_branch__msg.replace("{number}", fetchedData.uid);
				// 		notification.url = '/order-management/' + orderIdToUpdate;
				// 		notification.operation = 'notification-only'; */
				// 	/* }
				// 	else { */
				// 		notification.title = json_lang.firebase.started_orderprovider__title;
				// 		notification.msg = json_lang.firebase.started_orderprovider__msg.replace("{number}", fetchedData.uid);
				// 		notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 		notification.url = '/order-management/' + orderIdToUpdate;
				// 		notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 		notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	//}
				// 	break;

				default:
					//notification.title = json_lang.firebase.started_default__title;
					//notification.msg = json_lang.firebase.started_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'for_delivery':
			switch (PAYLOAD.type) {
				case 'order':
				// case 'order_provider':

					if (userHigherAccess !== COMPANY_ACCESS) {
						ignorePush = true;
					}

					notification.title = json_lang.firebase.started_order__title.replace("{status_type}", json_lang.order_status.arrived);
					notification.msg = json_lang.firebase.started_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id)).replace("{status_type}", json_lang.order_status.arrived);

					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				default:
					//notification.title = json_lang.firebase.for_delivery_default__title;
					//notification.msg = json_lang.firebase.for_delivery_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'completed':
			switch (PAYLOAD.type) {
				// case 'order_provider':
				// 	// ESTE CASO NO ESTA IMPLEMENTADO, se debe ajustar en el API q solo se mande una vez el push segun el caso
				// 	ignorePush = true;

				// 	notification.title = json_lang.firebase.completed_order__title;
				// 	notification.sound = sound && sound.order_delivered !== "off" ? sound.order_delivered : null;

				// 	notification.msg = json_lang.firebase.completed_order__msg.replace("{number}", fetchedData.uid);
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	break;

				case 'order':

					notification.title = json_lang.firebase.completed_order__title;
					notification.sound = sound && sound.order_delivered !== "off" ? sound.order_delivered : null;
					notification.msg = json_lang.firebase.completed_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				default:
					//notification.title = json_lang.firebase.completed_default__title;
					//notification.msg = json_lang.firebase.completed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'refused':
			switch (PAYLOAD.type) {
				case 'order':
					notification.title = json_lang.firebase.refused_order__title;
					notification.msg = json_lang.firebase.refused_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					notification.url = '/order-management/' + orderIdToUpdate;
					break;
				case 'bid':

					if (userHigherAccess !== COMPANY_ACCESS) {
						ignorePush = true;
					}
					notification.title = json_lang.firebase.refused_bid__title;
					notification.msg = json_lang.firebase.refused_bid__msg.replace("{number}", fetchedData.uid);
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = []; /* xHACER: */
					break;

				default:
					//notification.title = json_lang.firebase.refused_default__title;
					//notification.msg = json_lang.firebase.refused_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'assigned':
			switch (PAYLOAD.type) {
				// case 'order_provider':
				// case 'bid':
				// 	////// aqui empiezaaa

				// 	notification.title = json_lang.firebase.assigned_bid__title;
				// 	notification.msg = json_lang.firebase.assigned_bid__msg.replace("{number}", fetchedData.uid);
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	break;

				case 'order':
					let providerName = ""
					if(fetchedData && fetchedData.order_providers && fetchedData.order_providers.length > 0 ){
						providerName = fetchedData.order_providers[0].provider.name
					} else if (fetchedData && fetchedData.providers && fetchedData.providers.length ){
						providerName = fetchedData.providers[0].name;
					} else if (fetchedData && fetchedData.order_provider_snapshot && fetchedData.order_provider_snapshot.id ){
						providerName = fetchedData.order_provider_snapshot.provider.name;
					} else {
						providerName = "un nuevo repartidor";
					}
					notification.title = json_lang.firebase.assigned_order__title;
					notification.msg = json_lang.firebase.assigned_order__msg
									.replace("{number}", (fetchedData.uid || fetchedData.id) || "")
									.replace("{provider}", providerName);
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				default:
					//notification.title = json_lang.firebase.assigned_default__title;
					//notification.msg = json_lang.firebase.assigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;
		case 'shopper_assigned':
			switch (PAYLOAD.type) {
				// case 'order_provider':
				// case 'bid':
				// 	////// aqui empiezaaa

				// 	notification.title = json_lang.firebase.assigned_bid__title;
				// 	notification.msg = json_lang.firebase.assigned_bid__msg.replace("{number}", fetchedData.uid);
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	break;

				case 'order':
					let providerName = ""
					if(fetchedData && fetchedData.order_providers && fetchedData.order_providers.length > 0 ){
						providerName = fetchedData.order_providers[0].provider.name
					} else if (fetchedData && fetchedData.providers && fetchedData.providers.length ){
						providerName = fetchedData.providers[0].name;
					} else if (fetchedData && fetchedData.shopper_snapshot && fetchedData.shopper_snapshot.id ){
						providerName = fetchedData.shopper_snapshot.name;
					} else {
						providerName = "un nuevo shopper";
					}
					notification.title = json_lang.firebase.assigned_order__title;
					notification.msg = json_lang.firebase.assigned_order__msg
									.replace("{number}", (fetchedData.uid || fetchedData.id) || "")
									.replace("{provider}", providerName);
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				default:
					//notification.title = json_lang.firebase.assigned_default__title;
					//notification.msg = json_lang.firebase.assigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'unassigned':
			switch (PAYLOAD.type) {
				case 'order':

					notification.title = json_lang.firebase.unassigned_order__title;
					notification.msg = json_lang.firebase.unassigned_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id) || "");
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;
					
				// case 'order_provider':
				// 	notification.title = json_lang.firebase.unassigned_provider__title;
				// 	notification.msg = json_lang.firebase.unassigned_provider__msg.replace("{number}", (fetchedData.uid || fetchedData.id) || "");
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	break;

				default:
					//notification.title = json_lang.firebase.unassigned_default__title;
					//notification.msg = json_lang.firebase.unassigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;
		case 'shopper_unassigned':
			switch (PAYLOAD.type) {
				case 'order':

					notification.title = json_lang.firebase.unassigned_order__title;
					notification.msg = json_lang.firebase.unassigned_order_shopper__msg.replace("{number}", (fetchedData.uid || fetchedData.id) || "");
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;
					
				// case 'order_provider':
				// 	notification.title = json_lang.firebase.unassigned_shopper__title;
				// 	notification.msg = json_lang.firebase.unassigned_shopper__msg.replace("{number}", (fetchedData.uid || fetchedData.id) || "");
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				// 	break;

				default:
					//notification.title = json_lang.firebase.unassigned_default__title;
					//notification.msg = json_lang.firebase.unassigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'accepted':
			
			switch (PAYLOAD.type) {
				case 'bid':

					notification.title = json_lang.firebase.accepted_bid__title;
					notification.msg = json_lang.firebase.accepted_bid__msg
									.replace("{number}", (fetchedData && fetchedData.uid) || "")
									.replace("{provider}", (fetchedData && fetchedData.providers && fetchedData.providers[0] && fetchedData.providers[0].name) || "");
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = []; /* xHACER: */
					break;

				case 'order':
					notification.sound = sound && sound.order_accepted !== "off" ? sound.order_accepted : null;

					notification.title = json_lang.firebase.accepted_order__title;
					notification.msg = await json_lang.firebase.accepted_order__msg
								.replace("{number}", (fetchedData && fetchedData.uid) || "")
								.replace("{provider}", (fetchedData && fetchedData.providers && fetchedData.providers[0] && fetchedData.providers[0].name) || "");
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];

					if (userHigherAccess !== COMPANY_ACCESS) {
						// si soy branch necesito notificar al usuario recordando que el no puede ver un listado de todas las ordenes
						// si el supuesto caso que tengo acceso a varios comercios, y estoy en un comercio distinto al del push.. solo notificame , no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
						if (activeBranch && activeBranch.id && (fetchedData && fetchedData.branch && fetchedData.branch.id) !== activeBranch.id && hasListOfOrdersView){
							notification.operation = "notification-only";
						}
							

						if (fetchedData.branch){
							notification.title.replace("-", `- ${fetchedData.branch.name} -`)
						}
							

						notification.msg = fetchedData.uid ? json_lang.firebase.new_order__msg.replace("{number}", fetchedData.uid) : json_lang.firebase.new_order__msg.replace(" # {number} ", "");

						if (fetchedData.branch){
							notification.msg = fetchedData.branch.name + ": " + notification.msg;
						}

						if((PAYLOAD.type) && (session.admin_type_id === 2)){
							notification.operation = notification.related ? "replace-from-list" : 'append';
						}
						
					}
					break;

				case 'payment':

					notification.title = json_lang.firebase.accepted_payment__title;
					notification.msg = json_lang.firebase.accepted_payment__msg;
					notification.url = '/order-management/' + orderIdToUpdate;
					break;

				default:
					//notification.title = json_lang.firebase.accepted_default__title;
					//notification.msg = json_lang.firebase.accepted_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'changed':
			switch (PAYLOAD.type) {
				case 'order':
					notification.title = json_lang.firebase.changed_order__title;
					notification.msg = json_lang.firebase.changed_order__msg
							.replace("{number}", fetchedData.uid).replace("{status}", orderStatus(fetchedData.status).text );;
					notification.url = '/order-management/' + orderIdToUpdate;
					
					break;
				case 'coupon':
					const coupon = (notification && notification.related) || await fetchCoupon(notification.update.id);
					const isCouponsListView = ['/coupons'].includes(window.location.pathname);
					notification.update = {
						...coupon
					};

					if (userHigherAccess !== COMPANY_ACCESS) {
						ignorePush = true;
					}

					notification.title = json_lang.firebase.changed_coupon__title;
					notification.msg = json_lang.firebase.changed_coupon__msg.replace("{name}", coupon.name).replace("{status}", couponStatus(coupon.status).text );
					notification.url = '/coupons';
					notification.storeKey = 'coupons';
					notification.operation = isCouponsListView  ? 'replace-from-paginated-list' : "notification-only";
					break;

				case 'company':
					const company = (notification && notification.related) || await fetchCompany(notification.update.id);
					notification.update = {
						...company
					};

					notification.title = json_lang.firebase.changed_company__title;
					notification.msg = json_lang.firebase.changed_company__msg;
					notification.url = '/settings';
					notification.storeKey = 'company';
					notification.operation = 'replace';
					break;
				
				case 'branch':
					if(!fetchedData.id){
						fetchedData = await fetchBranch(notification.update.id);
					}
					notification.update = {
						...fetchedData
					};
					if (activeBranch && activeBranch.id && (notification.update && notification.update.id) === activeBranch.id) {
						localStorage.setItem('activeBranch', JSON.stringify(notification.update));
					}
					else {
						ignorePush = true;
					}

					notification.title = json_lang.firebase.changed_branch__title;
					notification.msg = json_lang.firebase.changed_branch__msg.replace("{branch}", fetchedData.name);
					notification.url = isBranchListView ? '/branchs' : '/settings';

					// si es un usuario owner y cambia el status de la sucursal a en servicio
					if (userHigherAccess === COMPANY_ACCESS/*  || ignorePush */){
						notification.storeKey = isBranchListView ? 'branchGroupList': null;
						notification.operation = isBranchListView ? 'replace-from-list': null;
					}
					else{
						// si es mi comercio y soy tipo branch actualizame lo que estoy viendo
						notification.storeKey = 'branch';
						notification.operation = 'replace';
					}
					break;

				default:
					//notification.title = json_lang.firebase.changed_default__title;
					//notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'in_service_changed':
			switch (PAYLOAD.type) {

				case 'branch':
					fetchedData = (payload.related || payload.data && payload.data.data) || await fetchBranch(notification.update.id);
					notification.update = { ...fetchedData };

					if ((activeBranch && activeBranch.id) && ((notification.update && notification.update.id) === activeBranch.id)) {
						ignorePush = false;
					}
					else {
						ignorePush = true;
					}

					notification.title = json_lang.firebase.changed_branch__title;
					notification.msg = json_lang.firebase.changed_branch__msg.replace("{branch}", fetchedData.name);
					notification.url = isBranchListView ? '/branchs' : '/settings';
					notification.sound = sound && sound.branch_in_service !== "off" ? sound.branch_in_service : null;

					// si es un usuario owner y cambia el status de la sucursal a en servicio
					if (userHigherAccess === COMPANY_ACCESS /*  || ignorePush */ ) {
						notification.storeKey = isBranchListView ? 'branchGroupList' : null;
						notification.operation = isBranchListView ? 'replace-from-list' : null;
					} else {
						// si es mi comercio y soy tipo branch actualizame lo que estoy viendo
						notification.storeKey = 'branch';
						notification.operation = 'replace';
					}
					break;

				default:
					//notification.title = json_lang.firebase.changed_default__title;
					//notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'being_prepared':
			switch (PAYLOAD.type) {
				case 'order':

					/* if (fetchedData
						&& fetchedData.providers
						&& fetchedData.providers.length
					) {
					} */
					notification.title = json_lang
											&& json_lang.firebase
											&& json_lang.firebase.being_prepared_order__title
											&& json_lang.firebase.being_prepared_order__title.replace("{number}", fetchedData.uid);

					let msg = json_lang.firebase.being_prepared_order__msg.split(".")
					if(fetchedData.eta){
						msg = msg.join(".")
						msg = json_lang.firebase.being_prepared_order__msg.replace("{eta}", fetchedData.eta);
					}
					else {
						msg = msg[0];
					}

					notification.msg = msg;
					notification.sound = sound && sound.order_being_prepared !== "off" ? sound.order_being_prepared : null;
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
				break;

				default:
					//notification.title = json_lang.firebase.changed_default__title;
					//notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'prepared':
			switch (PAYLOAD.type) {
				case 'order':
					if(fetchedData && !fetchedData.provider_id){
						notification.title = json_lang.firebase.prepared_order__title.replace("{number}", fetchedData.uid);
						notification.sound = sound && sound.order_prepared !== "off" ? sound.order_prepared : null;
						
						if(
							fetchedData.is_provider_assigned
							&& fetchedData.order_provider_snapshot
							&& fetchedData.order_provider_snapshot.id
						){
							notification.msg = json_lang.firebase.prepared_order__msg.replace("{provider}", ("para el repartidor " + fetchedData.order_provider_snapshot.provider.name));								
						} else{
							let textt = fetchedData.status_data && fetchedData.status_data.is_provider_required === true ? 'y no tiene Rider asignado' :''
							notification.msg = json_lang.firebase.prepared_order__msg.replace("{provider}", textt);
						}
						notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
						notification.url = '/order-management/' + orderIdToUpdate;
						notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
						notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					}
					else
						ignorePush = true;
					break;

				default:
					//notification.title = json_lang.firebase.changed_default__title;
					//notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'in_destination':
			
			switch (PAYLOAD.type) {
				case 'order':	

					/* if (userHigherAccess < COMPANY_ACCESS)
						ignorePush = true; */

					notification.title = json_lang.firebase.in_destination_order__title;
					notification.sound = sound && sound.order_arrived !== "off" ? sound.order_arrived : null;

					notification.msg = fetchedData.uid ? json_lang.firebase.in_destination_order__msg.replace("{number}", fetchedData.uid) : json_lang.firebase.in_destination_order__msg.replace(" # {number} ", "");
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
					break;

				// case 'order_provider':
				// 	/* if (userHigherAccess < COMPANY_ACCESS){
				// 		ignorePush = true;
				// 		break;
				// 	} */

				// 	notification.title = json_lang.firebase.in_destination_order_provider__title;
				// 	notification.sound = sound && sound.order_arrived !== "off" ? sound.order_arrived : null;
				// 	notification.msg = json_lang.firebase.in_destination_order_provider__msg.replace("{number}", fetchedData.uid);
				// 	notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				// 	notification.url = '/order-management/' + orderIdToUpdate;
				// 	notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				// 	notification.touchedPropsToReplace = []; /* xHACER: */
				// 	break;

				default:
					//notification.title = json_lang.firebase.changed_default__title;
					//notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'collected':
			switch (PAYLOAD.type) {
                case "order":
                    let isService =
                        (fetchedData.status & MASK_SERVICE_TYPE) ===
                        TYPE_SERVICES;

                    const status_type =
                        !isPickUp(
                            fetchedData.client_latitude_e6,
                            fetchedData.client_longitude_e6,
                            fetchedData.client_address
                        ) && !isService
                            ? json_lang.firebase.the_way
                            : json_lang.firebase.progress;

                    notification.title =
                        json_lang.firebase.started_order__title.replace(
                            "{status_type}",
                            status_type
                        );
                    notification.msg = json_lang.firebase.started_order__msg
                        .replace("{number}", fetchedData.uid || fetchedData.id)
                        .replace("{status_type}", status_type);

                    notification.operation = hasListOfOrdersView
                        ? "replace-from-list"
                        : "replace";
                    notification.url = "/order-management/" + data.id;
                    notification.storeKey =
                        notification.operation === "replace"
                            ? "order"
                            : isMapView
                            ? "filteredMapOrders"
                            : "orders";
                    notification.touchedPropsToReplace = [
                        "status",
                        "provider",
                        "provider_id",
                        "updated_at",
                    ];
                    break;

                // case "order_provider":                   

                //     notification.title =
                //         json_lang.firebase.collected_order_provider__title;

                //     notification.msg =
                //         json_lang.firebase.collected_order_provider__msg.replace(
                //             "{number}",
                //             fetchedData.uid
                //         );
                //     notification.operation = hasListOfOrdersView
                //         ? "replace-from-list"
                //         : "replace";
                //     notification.url = "/order-management/" + fetchedData.id;
                //     notification.storeKey =
                //         notification.operation === "replace"
                //             ? "order"
                //             : isMapView
                //             ? "filteredMapOrders"
                //             : "orders";
                //     notification.touchedPropsToReplace = []; /* xHACER: */
                //     break;

                default:
                    //notification.title = json_lang.firebase.changed_default__title;
                    //notification.msg = json_lang.firebase.changed_default__msg.replace("{type}", PAYLOAD.type);
                    break;
            }
			break;

		case 'paid':
			switch (PAYLOAD.type) {
				case 'order':
					// hoy 15-10-2020 cae en este caso, si se pago por efectivo (digo por si cambia en el futuro o se agregan nuevos casos)

					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';

					if (userHigherAccess !== COMPANY_ACCESS) {
						notification.title = json_lang.firebase.available_order__title;
						notification.msg = json_lang.firebase.available_order__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
					}
					else {
						notification.title = json_lang.firebase.paid_order__msg;
						notification.msg = fetchedData.uid ? json_lang.firebase.paid_order__title.replace("{number}", fetchedData.uid) : json_lang.firebase.paid_order__title.replace(" # {number} ", "");
						if (fetchedData.branch){
							notification.title.replace("-", `- ${fetchedData.branch.name} -`)
							notification.msg = fetchedData.branch.name + ": " + notification.msg;
						}
						// pero si el supuesto caso que tengo acceso a varios comercios, y estoy en un comercio distinto al del push.. solo notificame , no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
						if (activeBranch && activeBranch.id && (fetchedData && fetchedData.branch && fetchedData.branch.id) !== activeBranch.id && hasListOfOrdersView) {
							notification.operation = "notification-only";
						}
						else {
							notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
							notification.storeKey = isMapView ? 'filteredMapOrders' : 'orders';
						}
					}
				break;

				default: 
				break;
			}
			break;

		case 'post_pay':
			switch (PAYLOAD.type) {
				case 'order':
					ignorePush = true;
					break;

				default:
					//notification.title = json_lang.firebase.unassigned_default__title;
					//notification.msg = json_lang.firebase.unassigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;

		case 'pool_changed':
			switch (PAYLOAD.type) {
				case 'order':
					//console.log("notification.update",notification,PAYLOAD)
					notification.title = json_lang.firebase.pool_changed__title;
					notification.msg = json_lang.firebase.pool_changed__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
				
					break;

				default:
					//notification.title = json_lang.firebase.unassigned_default__title;
					//notification.msg = json_lang.firebase.unassigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;
		case 'inventory_outdated':
			switch (PAYLOAD.type){
				case 'branch':
					notification.title = json_lang.firebase.inventory_outdated__title;
					notification.msg = json_lang.firebase.inventory_outdated__msg.replace("{name}", (fetchedData.name || ""));
					if (activeBranch && activeBranch.id && (notification.update && notification.update.id) === activeBranch.id) {
						notification.url = '/goods-management';
					}
					else {
						notification.url = '/';
					}
					break;
			}
			break;
		
		case 'payment_reported':
			switch (PAYLOAD.type) {
				case 'order':
					if ( !(userHigherAccess === COMPANY_ACCESS) ) { // si soy owner oculta
						ignorePush = true;
					}
					notification.title = json_lang.firebase.new_payment__title;
					notification.sound = sound && sound.payment_new !== "off" ? sound.payment_new : null;
					notification.msg = json_lang.firebase.new_payment__msg.replace("{number}", (fetchedData && fetchedData.uid));
					notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
					notification.url = '/order-management/' + orderIdToUpdate;
					notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
					//notification.touchedPropsToReplace = ["status"]; */
					break;
				default:
					//notification.title = json_lang.firebase.unassigned_default__title;
					//notification.msg = json_lang.firebase.unassigned_default__msg.replace("{type}", PAYLOAD.type);
					break;
			}
			break;
		default:
			// case "orden no entregada":
			if ( (notification.update.status & (0x2000 | 0x18000) ) === (0x2000 | 0x18000) ) {

				notification.title = json_lang.firebase.order_not_delivered__title;
				notification.msg = json_lang.firebase.order_not_delivered__msg.replace("{number}", (fetchedData.uid || fetchedData.id));
				notification.operation = hasListOfOrdersView ? 'replace-from-list' : 'replace';
				notification.url = '/order-management/' + orderIdToUpdate;
				notification.storeKey = notification.operation === 'replace' ? 'order' : isMapView ? 'filteredMapOrders' : 'orders';
				notification.touchedPropsToReplace = ["status", "provider", "provider_id", "updated_at"];
			}
			// case dafault:
			else {
				//notification.title = json_lang.firebase.default__title;
				//notification.msg = json_lang.firebase.default__msg.replace("{type}", PAYLOAD.type);
			}
			break;
	}

	//debugger;
	if(notification && notification.update && notification.update.error) throw notification.update.error;

	// si es un usuario branch y no esta en la sucursal que debe llegar el push, la oculta
    if (ignorePush && (userHigherAccess !== COMPANY_ACCESS)) return;

	// !notification.title = esto es para el caso q me llegue un push pero
	// no deba mostrar notificacion ejm post_pay.order
	if (!notification.title) return;

	//debugger
	return notification;
}

export {
	notificationOptionSetting
};




/* ONLINE STATUS API CALL */

let ONLINE_STATUS_INTERVAL;

const onlineStatusApiCall = () => {
	if (Boolean(localStorage.getItem('user')) && store.getState().userIsOnline) {
		axios.post(URLstring + store.getState().company.id + '/admins/' + store.getState().session.id + '/set-online')
			.then(() => {
				localStorage.setItem('userIsOnline', true);
			})
			.catch((err) => {
				localStorage.setItem('userIsOnline', false);
				clearInterval(ONLINE_STATUS_INTERVAL)
			})
	}
}

// send this request every 12 minutes in case... slow connections
ONLINE_STATUS_INTERVAL = window.setInterval(onlineStatusApiCall, 750000)//180000)



// WEBPACK FOOTER //
// ./src/push-notification.js